import { observer } from 'mobx-react-lite';
import React from 'react';
import { Box, Paper, useTheme } from '@mui/material';
import { useTeaserContext } from '../TeaserContext';
import { starBrandPalette } from '@jucy-ui/appearance';
import { Brand } from '#/lib/brand';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import { ManualPayment } from '#/components/Icons/ManualPayment';

type DealBannerInnerProps = { children: React.ReactNode; brand: Brand; disabled?: boolean };
const DealBannerInner = ({ brand, disabled, children }: DealBannerInnerProps) => {
    const theme = useTheme();
    const color = disabled ? theme.palette.grey['600'] : brand === 'star' ? starBrandPalette.seaBlue.DEFAULT : theme.palette.secondary.main;
    return (
        <Paper
            className="deal-banner"
            sx={(theme) => ({
                backgroundColor: color,
                color: theme.palette.common.white,
                py: 0.37,
                px: 2,
                display: 'flex',
                gap: 1,
                borderTopLeftRadius: theme.shape.borderRadius,
                borderTopRightRadius: theme.shape.borderRadius,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                ['& + .fleet-category-teaser']: {
                    borderTopWidth: 0,
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                },
            })}
        >
            {disabled ? <InfoOutlineIcon /> : <ManualPayment sx={{ width: '24px', height: '24px' }} />}
            <Box sx={{ pt: '2px', fontSize: '14px', fontWeight: 'bold' }}>{children}</Box>
        </Paper>
    );
};
DealBannerInner.displayName = 'DealBannerInner';

const DealBanner: React.FC = observer(() => {
    const { deal, brand } = useTeaserContext();
    if (!deal?.isBannerVisible) {
        return null;
    }

    return (
        <DealBannerInner brand={brand} disabled={!deal.enabled}>
            {deal.title}
        </DealBannerInner>
    );
});
DealBanner.displayName = 'DealBanner';

export default DealBanner;
